﻿window.cObjetUtilisateurMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    //if (Me.objet.bddRef.mGetArray("societe") != null) {
    //    Me.objet.bddRef.mGetArray("utilisateur").filter(function (o) { return o.administrateur == "1" }).forEach(function (o) {
    //        if (Me.objet.bddRef.mGetArray("societe").filter(function (soc) { return soc.date_abandon == null && o.id_societe_defaut == soc.id_societe }).length == 0) {
    //            if (Me.objet.bddRef.mGetArray("societe").filter(function (soc) { return soc.abandon == "0" }).length == 0) { o.id_societe_defaut = null }
    //            else { o.id_societe_defaut = Me.objet.bddRef.mGetArray("societe").filter(function (soc) { return soc.date_abandon == null })[0].id_societe }
    //        }
    //        if (Me.objet.bddRef.utiCourant.id_utilisateur == o.id_utilisateur) Me.objet.bddRef.utiCourant.id_societe_defaut = o.id_societe_defaut
    //    })
    //}

    var Me = this;

    this.mGetLibBase = function () { return "Utilisateur"; }
    this.mGetAttributBase = function () { return "l'" }
    this.mGetNewLib = function () { return "Nouvel utilisateur"; }
    this.mGetLib1 = function () {
        var txt = ""
        if (typeof objet.data == "undefined") {
            txt = "inconnu"
        } else if ((objet.data.nom == null || objet.data.nom.length == 0) && (objet.data.prenom == null || objet.data.prenom.length == 0)) {
            txt = ((objet.data.adresse_email == null) ? "---" : objet.data.adresse_email)
        } else {
            txt += this.mGetNomUsuel()
            //if (objet.data.nom != null && objet.data.nom.length > 0) txt += objet.data.nom;
            //if (objet.data.prenom != null && objet.data.prenom.length > 0) {
            //    if (txt.length > 0) txt += " ";
            //    txt += objet.data.prenom;
            //}
        }
        if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        if (objet.data.adresse_email == null || objet.data.adresse_email.length == 0) { return "(aucun email)"; }
        else { return objet.data.adresse_email; }
    }

    this.mGetNomUsuel = function () {
        var txt = ""
        if (objet.data.nom != null && objet.data.nom.length > 0) txt += objet.data.nom;
        if (objet.data.prenom != null && objet.data.prenom.length > 0) {
            if (txt.length > 0) txt += " ";
            txt += objet.data.prenom;
        }
        return txt
    }

    this.mGetIcone = function (dataTemplate) {
        if (typeof dataTemplate == 'undefined') { return $("<i class='fas fa-user'/>"); }
        else if (dataTemplate.is_robot == "1") { return $("<i class='fas fa-robot'/>"); }
        else { return $("<i class='fas fa-user'/>"); }
    }

    this.mGetRadiusImage = function () { return "100%" }

    this.mGetResume = function () {
        var txt = "";
        if (typeof objet.data.prenom != 'undefined' && objet.data.prenom != null && objet.data.prenom.length > 0 && typeof objet.data.nom != 'undefined' && objet.data.nom != null && objet.data.nom.length > 0) {
            txt += objet.data.prenom[0].toUpperCase();
            txt += objet.data.nom[0].toUpperCase();
        }
        else {
            if ((typeof objet.data.prenom == 'undefined' || objet.data.prenom == null || objet.data.prenom.length == 0) && (typeof objet.data.nom == 'undefined' || objet.data.nom == null || objet.data.nom.length == 0)) { } else {
                if (typeof objet.data.prenom != 'undefined' && objet.data.prenom != null && objet.data.prenom.length > 0) txt += objet.data.prenom[0].toUpperCase() + ((objet.data.prenom.length > 1) ? objet.data.prenom[1].toUpperCase() : "");
                else { txt += objet.data.nom[0].toUpperCase() + ((objet.data.nom.length > 1) ? objet.data.nom[1].toUpperCase() : ""); }
            }
        }
        if (txt.length == 0 && typeof objet.data.adresse_email != 'undefined' && objet.data.adresse_email != null && objet.data.adresse_email.length > 0) txt = objet.data.adresse_email[0].toUpperCase() + ((objet.data.adresse_email.length > 1) ? objet.data.adresse_email[1].toUpperCase() : "");
        return txt;
    }

    ////les utilisateurs sont sur le client
    //this.mGetData = function (id) {
    //    var result = null;
    //    utilisateur.forEach(function (uti) { if (uti.id_utilisateur == id) result = uti; })
    //    return result;
    //}

    this.mInitNewData = function (data) {
        if (Me.objet.bddRef.nom_base.endsWith("_aagest")) { data.super_administrateur = 1; data.administrateur = 1 }
        else { data.super_administrateur = 0; data.administrateur = 0 }
    }

    this.mGetTxtWarning = function (data) {
        var txtWarning = ""
        if (data.adresse_email == null || data.adresse_email.length == 0) { txtWarning = "Aucune adresse email." }
        if (data.has_pwd == "0") {
            if (txtWarning.length > 0) txtWarning += "<br/>"
            txtWarning += "Pas de mot de passe"
        }
        if (txtWarning.length > 0) {
            txtWarning += "<br/><b>Cet utilisateur ne pourra pas se connecter sur votre environnement</b>"
        }
        if (txtWarning.length > 0) { return "<span class='dxwarningformtext'>" + txtWarning + "</span>"; } else { return ""; }
    }

    function mGetLstColum() {
        return [{
            dataField: "id_utilisateur",
            caption: "",
            width: 65,
            cellTemplate: function (cellElement, cellInfo) {
                $("<div style='width:100%;height:100%;'/>").appendTo(cellElement).dxCtrlImageData({
                    bddCtrl: Me.objet.bddRef,
                    //width: "100%",
                    size: 34,
                    objet: cellInfo.data
                })
            }
        }, {
            dataField: "nom", sortIndex: 0,
            sortOrder: "asc"
        }, {
            dataField: "prenom", sortIndex: 1,
            caption: "Prénom",
            sortOrder: "asc"
        }, {
            dataField: "adresse_email", sortIndex: 1,
            caption: "Email"
        }, {
            dataField: "",
            caption: "",
            width: 60,
            cellTemplate: function (cellElement, cellInfo) {
                var contenu = Me.mGetTxtWarning(cellInfo.data);
                if (contenu.length > 0) {
                    $d = $("<i class='fas fa-exclamation-triangle dx-theme-accent-as-text-color' style='font-size:24px'/>").appendTo(cellElement);
                    var tt = null;
                    $d.on("mouseenter", function () {
                        var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                            target: $d,
                            width: 200,
                            showCloseButton: false,
                            visible: true,
                            contentTemplate: function (contentElement) {
                                $("<div class='dx-theme-accent-as-text-color' style='white-space:normal'>" + contenu + "</div>").appendTo(contentElement)
                            }
                        }).dxCtrlTooltip("instance");
                        tt.show();
                    });
                    $d.on("mouseleave", function () { if (tt) { tt.hide(); tt = null; } });
                }
            }
        }]
    }
    this.contentTemplateGrid = function (contentElement, option) {

    }

    //POPUP CONTENT
    function mGetLstItem(funcSave, option) {
        var itemsDetails = [];
        var items1 = {
            nom: "Coordonnées", items: [{
                dataField: "id_utilisateur", visible: false
            }, {
                itemType: "group",
                name: 'grpimg',
                caption: " ",
                items: [{
                    caption: "",
                    template: function (itemData, itemElement) {
                        $("<div style='width:100%;height:100%;'/>").appendTo(itemElement).dxCtrlImageData({
                            bddCtrl: Me.objet.bddRef,
                            size: 180,
                            data: objet.data
                        }).dxCtrlImageData("instance");
                    }
                }],
                colSpanXs: 6, colSpanSm: 6, colSpanMd: 6, colSpanLg: 6
            }, {
                itemType: "group",
                name: 'grpnom',
                caption: "",
                items: mGetLstItemEntete(objet.data, 1, funcSave).concat([{
                    dataField: "pwd", name: "pwd", label: { text: "Mot de passe", location: "left", visible: false },
                    template: function (itemData, itemElement) {
                        itemElement.parent().css("padding-top", 0)
                        if (objet.data.id_utilisateur == null) {
                            $("<div/>").appendTo(itemElement).dxCtrlPopupPwd({
                                value: itemData,
                                funcOk: function (pwd) {
                                    objet.data.pwd = pwd
                                    if (pwd.length > 0) objet.data.has_pwd = 1;
                                    funcSave(itemData.dataField)
                                }
                            })
                        } else {
                            $("<div style='width:100%'/>").appendTo(itemElement).dxCtrlButton({
                                text: "Réinitialiser mot de passe",
                                width: "100%",
                                onClick: function (e) {
                                    jaugeDemarrage.mShow();
                                    var dataToBeSent = {
                                        command: 'demandereinitpwdwithid',
                                        adresse_email: objet.data.adresse_email,
                                        nom_table: "utilisateur",
                                        id: objet.data.id_utilisateur
                                    }
                                    var url = '/ext/handlerexterne.ashx?timestamp=' + new Date().getTime();
                                    $.post(url, dataToBeSent, function (data) {
                                        if (data.root.resultat == "ok") {
                                            if (data.root.emailenvoye == "1") {
                                                mNotify("Un email vous permettant de réinitialiser votre mot de passe vous a été envoyé. Veuillez consulter vos emails et suivre les instructions.<br/>(Si vous ne recevez pas notre email, vérifiez que celui-ci ne se trouve pas dans vos courriers indésirables)", "success", 10000)
                                            } else {
                                                mNotify("Impossible de vous envoyer un email de réinitialisation.", "error", 15000)
                                            }
                                        }
                                        else {
                                            if (typeof data.root.message != 'undefined') { mNotify(data.root.message, "error", 5000) }
                                            else { mNotify("Impossible d'envoyer l'email de réinitialisation.", "error", 15000); }
                                        }
                                    }, 'json')
                                        .fail(function (data) {
                                            console.log(data.responseText)
                                            mNotify("Impossible d'envoyer l'email de réinitialisation.", "error", 15000);
                                        })
                                        .always(function (data) {
                                            jaugeDemarrage.mHide();
                                        });
                                }
                            });
                        }
                    },
                    colSpanXs: 1, colSpanSm: 1, colSpanMd: 1, colSpanLg: 1
                }, {
                    dataField: "tel_sms", name: "tel_sms", label: { visible: false, text: ".", location: "left" },
                    template: function (itemData, itemElement) {
                        var dataTel = {
                            tel_code_pays: objet.data.tel_code_pays,
                            tel_number: objet.data.tel_number,
                            tel_complet: objet.data.tel_complet,
                            tel_sms: objet.data.tel_sms,
                            tel_error: objet.data.tel_error,
                            tel_num_type: objet.data.tel_num_type
                        }
                        $("<div/>").appendTo(itemElement).dxCtrlTelephone({
                            labelMode: 'floating',
                            label: "Téléphone",
                            value: dataTel,
                            onValueChanged: function (e) {
                                objet.data.tel_code_pays = e.value.tel_code_pays;
                                objet.data.tel_number = e.value.tel_number;
                                objet.data.tel_complet = e.value.tel_complet;
                                objet.data.tel_sms = e.value.tel_sms;
                                objet.data.tel_error = e.value.tel_error;
                                objet.data.tel_num_type = e.value.tel_num_type;
                                objet.mSave();
                            }
                        }).dxCtrlTelephone("instance")
                        var contentLabel = $(itemElement.parent().find(".dx-field-item-label-content"))
                        contentLabel.empty()
                        $("<i class='fas fa-phone'/>").appendTo(contentLabel)
                    },
                    colSpanXs: 1, colSpanSm: 1, colSpanMd: 1, colSpanLg: 1
                }, {
                    dataField: "mob_sms", name: "mob_sms", label: { visible: false, text: ".", location: "left" },
                    template: function (itemData, itemElement) {
                        var dataTel = {
                            tel_code_pays: objet.data.mob_code_pays,
                            tel_number: objet.data.mob_number,
                            tel_complet: objet.data.mob_complet,
                            tel_sms: objet.data.mob_sms,
                            tel_error: objet.data.mob_error,
                            tel_num_type: objet.data.mob_num_type
                        }
                        $("<div/>").appendTo(itemElement).dxCtrlTelephone({
                            labelMode: 'floating',
                            label: "Mobile",
                            value: dataTel,
                            typeTel: "mob",
                            onValueChanged: function (e) {
                                objet.data.mob_code_pays = e.value.tel_code_pays;
                                objet.data.mob_number = e.value.tel_number;
                                objet.data.mob_complet = e.value.tel_complet;
                                objet.data.mob_sms = e.value.tel_sms;
                                objet.data.mob_error = e.value.tel_error;
                                objet.data.mob_num_type = e.value.tel_num_type;
                                objet.mSave();
                            }
                        }).dxCtrlTelephone("instance")
                        var contentLabel = $(itemElement.parent().find(".dx-field-item-label-content"))
                        contentLabel.empty()
                        $("<i class='fas fa-mobile-alt'/>").appendTo(contentLabel)
                    },
                    colSpanXs: 1, colSpanSm: 1, colSpanMd: 1, colSpanLg: 1
                }]),
                colSpanXs: 10, colSpanSm: 10, colSpanMd: 10, colSpanLg: 10
            }, {
                dataField: "fonction", label: { visible: false, location: "left", text: "Fonction" },
                template: function (itemData, itemElement) {
                    itemElement.parent().css("padding-top", 0)
                    $("<div/>").appendTo(itemElement).dxCtrlTextBox({
                        labelMode: 'floating',
                        label: "Fonction",
                        value: objet.data.fonction,
                        placeholder: "Fonction de l'utilisateur dans l'entreprise...",
                        onValueChanged: function (e) { objet.data.fonction = e.value; funcSave(itemData.dataField) }
                    });
                },
                colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
            //}, {
            //    dataField: "administrateur", name: "administrateur", label: { text: "administrateur", visible: false },
            //    template: function (itemData, itemElement) {
            //        var hint = "Les utilisateurs administrateurs ont accès à la création, consultation et modification des utilisateurs."
            //        if (Me.objet.bddRef.utiCourant.administrateur != 1) {
            //            hint += "<br/>Seul les utilisateurs administrateurs peuvent modifier le statut d'administrateur d'un utilisateur"
            //        } else if (objet.data.id_utilisateur == Me.objet.bddRef.utiCourant.id_utilisateur) {
            //            hint += "<br/>Vous ne pouvez pas modifier le statut d'administrateur de votre profil connecté.<br/>Seul un autre profil administrateur peut modifier votre statut d'administrateur."
            //        }
            //        $("<div/>").appendTo(itemElement).dxCheckBox({
            //            text: "Administrateur",
            //            focusStateEnabled: false,
            //            disabled: (Me.objet.bddRef.utiCourant.administrateur != 1 || objet.data.id_utilisateur == Me.objet.bddRef.utiCourant.id_utilisateur),
            //            hint: hint,
            //            value: (objet.data.administrateur == "1"),
            //            onValueChanged: function (e) {
            //                objet.data.administrateur = ((e.value) ? "1" : "0");
            //                funcSave(itemData.dataField)
            //            }
            //        }).dxCheckBox("instance");
            //    },
            //    visible: (Me.objet.bddRef.utiCourant.administrateur == 1),
            //    colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
            //}, {
            //    dataField: "date_abandon", name: "date_abandon", label: { text: "Utilisateur abandonné", visible: false },
            //    template: function (itemData, itemElement) {
            //        $("<div/>").appendTo(itemElement).dxCheckBox({
            //            text: "Utilisateur abandonné",
            //            focusStateEnabled: false,
            //            disabled: (Me.objet.bddRef.utiCourant.administrateur != 1 || objet.data.id_utilisateur == Me.objet.bddRef.utiCourant.id_utilisateur),
            //            value: ((objet.data.date_abandon != null) ? true : false),
            //            onValueChanged: function (e) {
            //                objet.data.date_abandon = ((e.value) ? new Date() : null);
            //                funcSave(itemData.dataField)
            //            }
            //        }).dxCheckBox("instance");
            //    },
            //    visible: (Me.objet.bddRef.utiCourant.administrateur == 1),
            //    colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
            }]
        }
        if (parametre.baseAppli.para.is_multi_utilisateur == "1") {
            items1.items = items1.items.concat([{
                dataField: "administrateur", name: "administrateur", label: { text: "administrateur", visible: false },
                template: function (itemData, itemElement) {
                    var hint = "Les utilisateurs administrateurs ont accès à la création, consultation et modification des utilisateurs."
                    if (Me.objet.bddRef.utiCourant.administrateur != 1) {
                        hint += "<br/>Seul les utilisateurs administrateurs peuvent modifier le statut d'administrateur d'un utilisateur"
                    } else if (objet.data.id_utilisateur == Me.objet.bddRef.utiCourant.id_utilisateur) {
                        hint += "<br/>Vous ne pouvez pas modifier le statut d'administrateur de votre profil connecté.<br/>Seul un autre profil administrateur peut modifier votre statut d'administrateur."
                    }
                    $("<div/>").appendTo(itemElement).dxCheckBox({
                        text: "Administrateur",
                        focusStateEnabled: false,
                        disabled: (Me.objet.bddRef.utiCourant.administrateur != 1 || objet.data.id_utilisateur == Me.objet.bddRef.utiCourant.id_utilisateur),
                        hint: hint,
                        value: (objet.data.administrateur == "1"),
                        onValueChanged: function (e) {
                            objet.data.administrateur = ((e.value) ? "1" : "0");
                            funcSave(itemData.dataField)
                        }
                    }).dxCheckBox("instance");
                },
                visible: (Me.objet.bddRef.utiCourant.administrateur == 1),
                colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
            }, {
                dataField: "date_abandon", name: "date_abandon", label: { text: "Utilisateur abandonné", visible: false },
                template: function (itemData, itemElement) {
                    $("<div/>").appendTo(itemElement).dxCheckBox({
                        text: "Utilisateur abandonné",
                        focusStateEnabled: false,
                        disabled: (Me.objet.bddRef.utiCourant.administrateur != 1 || objet.data.id_utilisateur == Me.objet.bddRef.utiCourant.id_utilisateur),
                        value: ((objet.data.date_abandon != null) ? true : false),
                        onValueChanged: function (e) {
                            objet.data.date_abandon = ((e.value) ? new Date() : null);
                            funcSave(itemData.dataField)
                        }
                    }).dxCheckBox("instance");
                },
                visible: (Me.objet.bddRef.utiCourant.administrateur == 1),
                colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
            }])
        }
        itemsDetails.push(items1)
        return itemsDetails
    }
    function mGetLstItemEntete(dataUti, colSpan, funcSave) {
        return [{
            dataField: "nom", label: { visible: false, text: String.fromCharCode(8203) + "Nom", location: "left" },
            template: function (itemData, itemElement) {
                $("<div/>").appendTo(itemElement).dxCtrlTextBox({
                    labelMode: 'floating',
                    label: "Nom",
                    value: dataUti.nom,
                    name: "nkjkj",
                    inputAttr: { autocomplete: 'test-autocomplete' },
                    placeholder: "Saisissez le nom...",
                    maxLength: 255,
                    onValueChanged: function (e) {
                        dataUti.nom = e.value;
                        if (typeof funcSave != 'undefined') funcSave(itemData.dataField)
                    }
                })
            },
            colSpanXs: colSpan, colSpanSm: colSpan, colSpanMd: colSpan, colSpanLg: colSpan
        }, {
            dataField: "prenom", name: "prenom", label: { visible: false, text: "Prénom", location: "left" },
            template: function (itemData, itemElement) {
                $("<div/>").appendTo(itemElement).dxCtrlTextBox({
                    labelMode: 'floating',
                    label: "Prénom",
                    value: dataUti.prenom,
                    name: "kljlkjlkjmlluui",
                    placeholder: "Saisissez le prénom...",
                    maxLength: 255,
                    onValueChanged: function (e) {
                        dataUti.prenom = e.value;
                        if (typeof funcSave != 'undefined') funcSave(itemData.dataField)
                    }
                })
            },
            colSpanXs: colSpan, colSpanSm: colSpan, colSpanMd: colSpan, colSpanLg: colSpan
        }, {
            dataField: "adresse_email", name: "adresse_email", label: { visible: false, text: "@", location: "left" },
            template: function (itemData, itemElement) {
                var lstEmail = []
                Me.objet.bddRef.mAjaxCall({ command: "getlstemailutilisateur" }, function (data) {
                    if (typeof data.email == "undefined") data.email = []
                    data.email.forEach(function (mail) {
                        if (mail != dataUti.adresse_email) lstEmail.push(mail)
                    });
                });
                itemData.component.dxTxtBoxEmail = $("<div/>").appendTo(itemElement).dxCtrlTextEmail({
                    labelMode: 'floating',
                    label: "Adresse email",
                    name: "hkjgkhkj",
                    value: dataUti.adresse_email,
                    placeholder: "Saisissez l'adresse email...",
                    maxLength: 500,
                    onValueChanged: function (e) {
                        if (dataUti.adresse_email != e.value) {
                            if (lstEmail.contains(e.value)) {
                                mNotify("Cette adresse email est déjà liée à un utilisateur, vous ne pouvez pas l'utiliser.", "warning", 6000)
                                //itemData.component.dxTxtBoxEmail.mDisplayErreur("Cette adresse email est déjà liée à un utilisateur, vous ne pouvez pas l'utiliser.")
                                e.component.option("value", dataUti.adresse_email)
                                itemData.component.dxTxtBoxEmail.emailExisteDeja = "existe";
                            } else {
                                if (typeof funcSave != 'undefined') {
                                    //on valide l'adresse email
                                    $("<div/>").appendTo("body").dxCtrlSaisieCode({
                                        bddCtrl: Me.objet.bddRef,
                                        title: "Confirmez l'adresse email",
                                        adresse_email: e.value,
                                        from: "Change adresse email utilisateur (cObjetUtilisateurMetier)",
                                        onValide: function () {
                                            itemData.component.dxTxtBoxEmail.mNoErreur();
                                            itemData.component.dxTxtBoxEmail.emailExisteDeja = "existepas";
                                            dataUti.adresse_email = e.value
                                            funcSave("adresse_email")
                                            mNotify("Vous avez modifié l'adresse email.", "success", 6000)
                                        },
                                        onCancel: function () {
                                            mNotify("Vous avez annulé la vérification de l'adresse email.<br/>L'adresse email n'a pas été modifiée.", "warning", 6000)
                                            e.component.option("value", dataUti.adresse_email)
                                            itemData.component.dxTxtBoxEmail.emailExisteDeja = "existe";
                                        }
                                    })
                                } else {
                                    dataUti.adresse_email = e.value
                                }
                                //if (e.value != dataUti.adresse_email) {
                                //    if (utiCourant.id_utilisateur == dataUti.id_utilisateur) {
                                //        //on a saisie un nouveau mail (modification) et l'utilisateur saisie son propre mail utilisateur
                                //        $("<div/>").appendTo("body").dxCtrlSaisieCode({
                                //            adresse_email: e.value,
                                //            title: "Confirmez votre email",
                                //            contentTemplateTop: function (contentElement) {
                                //                $("<div>Un message avec un code d'identification vous a été envoyé sur l'adresse email <u>" + e.value + "</u>.<br/>Veuillez saisir le code reçu pour valider la modification de votre adresse email.</div>").appendTo(contentElement)
                                //            },
                                //            contentTemplateBottom: function (contentElement) {
                                //                $("<div style='font-size:80%'><i>Je n'ai pas reçu le message</i></div>").appendTo(contentElement)
                                //                $("<div style='font-size:70%'><i>(Vérifiez dans vos courriers indésirables)</i></div>").appendTo(contentElement)
                                //            },
                                //            onValide: function () {
                                //                dataUti.adresse_email = e.value
                                //                if (typeof funcSave != 'undefined') funcSave("adresse_email")
                                //                e.component.option("disabled", true)
                                //            },
                                //            onCancel: function () {
                                //                e.component.option("value", dataUti.adresse_email)
                                //                e.component.focus()
                                //                mNotify("La saisie de votre adresse email a été annulée.", "warning", 6000)
                                //            }
                                //        })
                                //    } else {
                                //        //l'utilisateur courant crée/modifie un autre utilisateur
                                //        //on ne demande pas de code
                                //        dataUti.adresse_email = e.value
                                //        if (typeof funcSave != 'undefined') funcSave("adresse_email")
                                //        e.component.option("disabled", true)
                                //    }
                                //}
                            }
                        }
                    }
                }).dxCtrlTextEmail("instance");
                itemData.component.dxTxtBoxEmail.emailExisteDeja = "existepas";
            },
            colSpanXs: colSpan, colSpanSm: colSpan, colSpanMd: colSpan, colSpanLg: colSpan
        }]
    }
    this.contentTemplatePopup = function (contentElement, option) {

        if (objet.data.is_robot == "1") {
            if (contentElement.closest(".dx-popup").length == 1) {
                $(contentElement.closest(".dx-popup")[0]).dxPopup("instance").hide()
                mNotify("Vous ne pouvez pas afficher l'utilisateur robot...", "warning", 6000)
            }
        }

        var lstItemBase = mGetLstItem(function (nomChamp) { mSave(nomChamp); }, option)
        var lstItemMetier = [];
        if (typeof objet.objetMetier != 'undefined' && objet.objetMetier != null && typeof objet.objetMetier.mGetLstItem != 'undefined') lstItemMetier = objet.objetMetier.mGetLstItem(function (nomChamp) { mSave(nomChamp); })

        var dxWarning = $("<div style='margin:5px'/>").appendTo(contentElement).dxCtrlWarningForm({
            type: "warning",
            html: function () { return Me.mGetTxtWarning(objet.data); }
        }).dxCtrlWarningForm("instance")

        var ds = []
        lstItemBase.forEach(function (item) { ds.push(item.nom) })
        lstItemMetier.forEach(function (item) { ds.push(item.nom) })
        if (Me.objet.bddRef.objCptCli.objetMetier.hasEmail() && Me.objet.bddRef.baseAppli.para.email.has_reception_email) {
            //on utilise le module mail avec réception
            //on rajoute la config mail
            ds.push("Adresses emails")
        }
        if (parametre.baseAppli.para.is_multi_utilisateur == "1" && Me.objet.bddRef.utiCourant.administrateur == "1") {
            ds.push("Droits")
        }
        $("<div/>").appendTo(contentElement).dxAccordion({
            dataSource: ds,
            collapsible: (ds.length > 1),
            selectedIndex: ((option.showEmail) ? 1 : 0),
            itemTitleTemplate: function (itemData, itemIndex, titleElement) {
                titleElement.css("font-size", "20px");
                titleElement.addClass("dx-theme-accent-as-text-color")
                titleElement.text(itemData)
            },
            itemTemplate: function (itemData, itemIndex, itemElement) {
                switch (itemData) {
                    case "Droits":
                        $("<div/>").appendTo(itemElement).dxCtrlDroitsUtilisateur({
                            bddCtrl: objet.bddRef,
                            dataUti: objet.data,
                        })
                        break;
                    case "Adresses emails":
                        mContentTemplateParaEmail(itemElement)
                        break;
                    default:
                        lstItemBase.forEach(function (item) {
                            if (item.nom == itemData) {
                                var blocForm = $("<div/>").appendTo(itemElement).dxCtrlForm({
                                    formData: objet.data,
                                    items: item.items,
                                    visible: true
                                }).dxCtrlForm("instance");
                            }
                        })
                        lstItemMetier.forEach(function (item) {
                            if (item.nom == itemData) {
                                var blocForm = $("<div/>").appendTo(itemElement).dxCtrlForm({
                                    formData: objet.data,
                                    items: item.items,
                                    visible: true
                                }).dxCtrlForm("instance");
                            }
                        })
                        break;
                }
            }
        });

        function mContentTemplateParaEmail(contentElement) {
            var lstItem = [{
                label: { visible: false, text: "login", location: "left" },
                template: function (itemData, itemElement) {
                    var $Table = $("<table style='width:100%'/>").appendTo(itemElement)

                    var $Tr = $("<tr class='state-hover'/>").appendTo($Table)
                    var $Td = $("<td style='width:1px;white-space:nowrap;text-align:right;padding-right:5px;' class='dx-field-item-label-text'>Nom usuel:&nbsp;</td>").appendTo($Tr)
                    var $Td = $("<td style='width:100%' colspan='2'></td>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlTextBox({
                        label: "Nom usuel (Nom affiché à vos destinataires dans leur messagerie)",
                        labelMode: 'floating',
                        placeholder: "Saisissez le nom qui sera affiché à vos destinataires...",
                        value: objet.data.nom_usuel,
                        onValueChanged: function (e) {
                            objet.data.nom_usuel = e.value;
                            objet.mSaveChamp("nom_usuel");
                        }
                    }).dxCtrlTextBox("instance")
                    $Tr.attr("title", "Nom affiché aux destinataires de vos emails<br/>Si le nom usuel n'est pas défini sur l'adresse email,<br/>c'est ce nom usuel qui sera utilisé.")
                    //$("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: $Tr, position: "top", contentTemplate: function (contentElement) { $("<div style='font-size:110%;'>Nom affiché aux destinataires de vos emails<br/>Si le nom usuel n'est pas défini sur l'adresse email,<br/>c'est ce nom usuel qui sera utilisé.</div>").appendTo(contentElement); } }).dxCtrlTooltipHoverTarget("instance");

                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:100%' colspan='3'><hr style='opacity:0.3'/></td>").appendTo($Tr)

                    var $Tr = $("<tr class='state-hover'/>").appendTo($Table)
                    var $Td = $("<td style='width:1px;white-space:nowrap;text-align:right;padding-right:5px;' class='dx-field-item-label-text'>Signature:&nbsp;</td>").appendTo($Tr)
                    var $Td = $("<td style='width:100%' colspan='2'></td>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlSignatureEmail({
                        bddCtrl: Me.objet.bddRef,
                        data: objet.data,
                        txtTooltip: "Signature de vos emails",
                        titlePopupEmail: "Signature de vos emails",
                        onValueChanged: function (dataSignature) {
                            objet.mSaveChamp("data_signature");
                        }
                    }).dxCtrlSignatureEmail("instance")
                    ////$("<div/>").appendTo($Td).dxCtrlEmailData({
                    ////    bddCtrl: Me.objet.bddRef,
                    ////    value: objet.data.data_signature,
                    ////    txtTooltip: "Signature email générale",
                    ////    tooltipModif: "Modifier la signature",
                    ////    tooltipSupp: "Supprimer la signature",
                    ////    tooltipNew: "Créer une nouvelle signature",
                    ////    titlePopupEmail: "Signature générale adresse email",
                    ////    rempliTxtLib: function (contentElement, value) {
                    ////        var txtLib = ""
                    ////        if (value == null || value.length == 0) {
                    ////            txtLib = "<div style='color:" + theme.toastWarning + ";font-size:16px;'>(aucune signature générale)</div>"
                    ////            txtLib += "<div style='font-size:90%;'>Si la signature n'est pas définie au niveau de l'adresse email, il n'y aura pas de signature sur celle-ci.</div>"
                    ////        } else {
                    ////            txtLib = "<div style='color:" + theme.toastSuccess + ";font-size:16px;'>Signature générale active</div>"
                    ////            txtLib += "<div style='font-size:90%;'>Si la signature n'est pas définie au niveau de l'adresse email, c'est cette signature qui sera utilisée.</div>"
                    ////        }
                    ////        contentElement.html(txtLib)
                    ////    },
                    ////    onValueChanged: function (dataSignature) {
                    ////        objet.data.data_signature = dataSignature;
                    ////        objet.mSaveChamp("data_signature");
                    ////    }
                    ////}).dxCtrlEmailData("instance")
                    ////$Tr.attr("title", "Signature de vos adresse email<br/>Si cette signature est définie<br/>et qu'aucune signature n'est défini sur l'adresse mail utilisé,<br/>c'est cette signature qui est utilisé")
                    //////$("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: $Tr, position: "top", contentTemplate: function (contentElement) { $("<div style='font-size:110%;'>Signature de vos adresse email<br/>Si cette signature est définie<br/>et qu'aucune signature n'est défini sur l'adresse mail utilisé,<br/>c'est cette signature qui est utilisé</div>").appendTo(contentElement); } }).dxCtrlTooltipHoverTarget("instance");

                    //var $Tr = $("<tr/>").appendTo($Table)
                    //var $Td = $("<td style='width:100%' colspan='3'><hr style='opacity:0.3'/></td>").appendTo($Tr)


                    //var $Tr = $("<tr class='state-hover'/>").appendTo($Table)
                    //var $Td = $("<td style='width:1px;white-space:nowrap;text-align:right;padding-right:5px;' class='dx-field-item-label-text'>Délai d'attente<br/>d'envoi de vos emails<br/>(secondes):&nbsp;</td>").appendTo($Tr)
                    //var $Td = $("<td style='width:250px'></td>").appendTo($Tr)
                    //$("<div style='width:100%'/>").appendTo($Td).dxCtrlNumberBox({
                    //    label: "Délai d'attente en secondes",
                    //    labelMode: 'floating',
                    //    placeholder: "",
                    //    value: objet.data.delai_envoi_secondes,
                    //    width: 250,
                    //    onValueChanged: function (e) {
                    //        objet.data.delai_envoi_secondes = ((e.value == null) ? 0 : e.value)
                    //        objet.mSaveChamp("delai_envoi_secondes");
                    //    }
                    //}).dxCtrlNumberBox("instance")
                    //var $Td = $("<td style='width:100%'></td>").appendTo($Tr)
                    //$Tr.attr("title", "Si vous définissez un délai d'attente,<br/>vos mails sont envoyé par l'application après ce délai.<br/>Avant ce délai, vos emails envoyés restent affichés dans l'onglet 'Envoi en attente'.")
                    ////$("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: $Tr, position: "top", contentTemplate: function (contentElement) { $("<div style='font-size:110%;'>Si vous définissez un délai d'attente,<br/>vos mails sont envoyé par l'application aprés ce délai.<br/>Avant ce délai, vos emails envoyés restent affichés dans l'onglet 'Envoi en attente'.</div>").appendTo(contentElement); } }).dxCtrlTooltipHoverTarget("instance");

                    //var $Tr = $("<tr/>").appendTo($Table)
                    //var $Td = $("<td style='width:100%' colspan='3'><hr style='opacity:0.3'/></td>").appendTo($Tr)

                    //var $Tr = $("<tr class='state-hover'/>").appendTo($Table)
                    //var $Td = $("<td style='width:1px;white-space:nowrap;text-align:right;padding-right:5px;' class='dx-field-item-label-text'>Jours d'envoi<br/>de vos emails:&nbsp;</td>").appendTo($Tr)
                    //var $Td = $("<td style='width:100%' colspan='2'></td>").appendTo($Tr)
                    //$("<div/>").appendTo($Td).dxCtrlSelectJour({
                    //    value: objet.data.jour_envoi,
                    //    onValueChanged: function (e) {
                    //        objet.data.jour_envoi = e.value
                    //        objet.mSaveChamp("jour_envoi");
                    //        var dat = Me.mGetProchaineDateEnvoi()
                    //        $TdCalculDate.empty()
                    //        $("<div>" + dat.toFrenchDateTime() + " " + ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"][dat.getDay()] + "</div>").appendTo($TdCalculDate)
                    //    }
                    //})
                    ////$("<div style='width:100%'/>").appendTo($Td).dxCtrlLstCheckBox({
                    ////    label: "Jour d'envoi",
                    ////    labelMode: 'floating',
                    ////    placeholder: "",
                    ////    dataSource: ["Lu", "Ma", "Me", "Je", "Ve", "Sa", "Di"],
                    ////    value: ((typeof objet.data.jour_envoi == 'undefined' || objet.data.jour_envoi == null || objet.data.jour_envoi.length == 0) ? [] : objet.data.jour_envoi.split("|")),
                    ////    onValueChanged: function (e) {
                    ////        objet.data.jour_envoi = ""
                    ////        e.value.forEach(function (j) {
                    ////            if (objet.data.jour_envoi.length > 0) objet.data.jour_envoi += "|"
                    ////            objet.data.jour_envoi += j
                    ////        })
                    ////        objet.mSaveChamp("jour_envoi");
                    ////        var dat = Me.mGetProchaineDateEnvoi()
                    ////        $TdCalculDate.empty()
                    ////        $("<div>" + dat.toFrenchDateTime() + " " + ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"][dat.getDay()] + "</div>").appendTo($TdCalculDate)
                    ////    }
                    ////}).dxCtrlLstCheckBox("instance")
                    //$Tr.attr("title", "Vos emails quotidiens ne seront envoyé que durant les jours définis.<br/><i>(Si aucun jour n'est coché, alors vos emails seront envoyé tous les jours)</i><br/>Hors de ces jours, les emails que vous envoyez seront affichés dans l'onglet 'Envoi en attente'")
                    ////$("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: $Tr, position: "top", contentTemplate: function (contentElement) { $("<div style='font-size:110%;'>Vos emails quotidiens ne seront envoyé que durant les jours définis.<br/><i>(Si aucun jour n'est coché, alors vos emails seront envoyé tous les jours)</i><br/>Hors de ces jours, les emails que vous envoyez seront affichés dans l'onglet 'Envoi en attente'</div>").appendTo(contentElement); } }).dxCtrlTooltipHoverTarget("instance");

                    //var $Tr = $("<tr/>").appendTo($Table)
                    //var $Td = $("<td style='width:100%' colspan='3'><hr style='opacity:0.3'/></td>").appendTo($Tr)

                    //var $Tr = $("<tr class='state-hover'/>").appendTo($Table)
                    //var $Td = $("<td style='width:1px;white-space:nowrap;text-align:right;padding-right:5px;' class='dx-field-item-label-text'>Horaire d'envoi<br/>de vos emails:&nbsp;</td>").appendTo($Tr)
                    //var $Td = $("<td style='width:100%' colspan='2'></td>").appendTo($Tr)
                    ////var value = []
                    ////if (objet.data.horaire_envoi != null && objet.data.horaire_envoi.length > 0) objet.data.horaire_envoi.split("||").forEach(function (interval) {
                    ////    var timeDebut = interval.split("|")[0]
                    ////    var timeFin = interval.split("|")[1]
                    ////    value.push({
                    ////        time_debut: new Date(2023, 1, 2, parseInt(timeDebut.split(":")[0]), parseInt(timeDebut.split(":")[1]), 0),
                    ////        time_fin: new Date(2023, 1, 2, parseInt(timeFin.split(":")[0]), parseInt(timeFin.split(":")[1]), 0)
                    ////    })
                    ////})
                    //$("<div style='width:100%'/>").appendTo($Td).dxCtrlLstTimeBoxInterval({
                    //    label: "Horaire d'envoi",
                    //    labelMode: 'floating',
                    //    placeholder: "",
                    //    type: "time",
                    //    intervalMn: 15,
                    //    showDropDownButton: true,
                    //    value: objet.data.horaire_envoi,
                    //    onValueChanged: function (e) {
                    //        objet.data.horaire_envoi = e.value
                    //        //objet.data.horaire_envoi = ""
                    //        //e.value.forEach(function (timeInterval) {
                    //        //    if (objet.data.horaire_envoi.length > 0) objet.data.horaire_envoi += "||"
                    //        //    objet.data.horaire_envoi += timeInterval.time_debut.getHours() + ":" + timeInterval.time_debut.getMinutes() + "|" + timeInterval.time_fin.getHours() + ":" + timeInterval.time_fin.getMinutes()
                    //        //})
                    //        objet.mSaveChamp("horaire_envoi");
                    //        var dat = Me.mGetProchaineDateEnvoi()
                    //        $TdCalculDate.empty()
                    //        $("<div>" + dat.toFrenchDateTime() + " " + ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"][dat.getDay()] + "</div>").appendTo($TdCalculDate)
                    //    }
                    //}).dxCtrlLstTimeBoxInterval("instance")
                    //$Tr.attr("title", "Vos emails quotidiens ne seront envoyé<br/>que dans les horaires que vous aurez définies.<br/>Hors de ces horaires, les emails que vous envoyez seront affichés dans l'onglet 'Envoi en attente'")
                    ////$("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: $Tr, position: "top", contentTemplate: function (contentElement) { $("<div style='font-size:110%;'>Vos emails quotidiens ne seront envoyé<br/>que dans les horaires que vous aurez définies.<br/>Hors de ces horaires, les emails que vous envoyez seront affichés dans l'onglet 'Envoi en attente'</div>").appendTo(contentElement); } }).dxCtrlTooltipHoverTarget("instance");

                    //var $Tr = $("<tr style='display:none'/>").appendTo($Table)
                    //var $Td = $("<td style='width:1px;white-space:nowrap;text-align:right;padding-right:5px;' class='dx-field-item-label-text'>Ajouter<br/>signature:&nbsp;</td>").appendTo($Tr)
                    //var $TdCalculDate = $("<td style='width:100%;padding:10px 0;' colspan='2'></td>").appendTo($Tr)
                    //var dat = Me.mGetProchaineDateEnvoi()
                    //$("<div>" + dat.toFrenchDateTime() + " " + ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"][dat.getDay()] + "</div>").appendTo($TdCalculDate)

                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:100%' colspan='3'><hr style='opacity:0.3'/></td>").appendTo($Tr)

                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:1px;white-space:nowrap;text-align:right;padding-right:5px;' class='dx-field-item-label-text'>Ajouter signature:&nbsp;</td>").appendTo($Tr)
                    var $Td = $("<td style='width:100%;padding:10px 0;' colspan='2'></td>").appendTo($Tr)

                    var $TableAjoutSignature = $("<table style='width:100%;'/>").appendTo($Td)
                    var $Tr = $("<tr/>").appendTo($TableAjoutSignature)
                    var $Td = $("<td style='width:6px;'></td>").appendTo($Tr)
                    var $Td = $("<td style=''></td>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlSwitch({
                        labelMode: "floating",
                        label: "Aux réponses",
                        txtTooltip: "Ajouter votre signature au début du message<br/>quand vous répondez à un email.",
                        value: (objet.data.repondre_avec_signature == 1),
                        onValueChanged: function (e) {
                            objet.data.repondre_avec_signature = ((e.value) ? "1" : "0")
                            objet.mSaveChamp("repondre_avec_signature");
                        }
                    })
                    var $Td = $("<td style=''></td>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlSwitch({
                        labelMode: "floating",
                        label: "Aux réponses à tous",
                        txtTooltip: "Ajouter votre signature au début du message<br/>quand vous répondez à tous les destinataires d'un email.",
                        value: (objet.data.repondre_tous_avec_signature == 1),
                        onValueChanged: function (e) {
                            objet.data.repondre_tous_avec_signature = ((e.value) ? "1" : "0")
                            objet.mSaveChamp("repondre_tous_avec_signature");
                        }
                    })
                    var $Td = $("<td style=''></td>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlSwitch({
                        labelMode: "floating",
                        label: "Aux transferts",
                        txtTooltip: "Ajouter votre signature au début du message<br/>quand vous transférez un email.",
                        value: (objet.data.transfert_avec_signature == 1),
                        onValueChanged: function (e) {
                            objet.data.transfert_avec_signature = ((e.value) ? "1" : "0")
                            objet.mSaveChamp("transfert_avec_signature");
                        }
                    })

                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:100%' colspan='3'><hr style='opacity:0.3'/></td>").appendTo($Tr)

                    //réponse automatique
                    var $Tr = $("<tr class='state-hover'/>").appendTo($Table)
                    var $Td = $("<td style='width:1px;white-space:nowrap;text-align:right;padding-right:5px;' class='dx-field-item-label-text'>Réponse<br/>automatique:&nbsp;</td>").appendTo($Tr)
                    var $Td = $("<td style='width:100%' colspan='2'></td>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlDefineRepAuto({
                        bddCtrl: Me.objet.bddRef,
                        data: objet.data
                    })
                    $Tr.attr("title", "Réponse automatique de vos adresses emails<br/>Si la réponse automatique est définie sur l'utilisateur<br/>tous vos compte email généreront une réponse automatique<br/>sur les emails reçus dans la période définie.")

                    var $Table = $("<table style='width:100%;'/>").appendTo(itemElement)
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:100%'/>").appendTo($Tr)
                    var $Div = $("<div style='white-space:nowrap;font-size:160%;margin-top:10px;' class='dx-theme-accent-as-text-color'>Liste des adresses emails:</td>").appendTo($Td)
                    var ds = Me.objet.bddRef.getObjet("utilisateur", objet.data.id_utilisateur).objetMetier.mGetLstDataCompteEmail()
                    var dxList = $("<div style=''/>").appendTo($Td).dxList({
                        dataSource: ds,
                        focusStateEnabled: false,
                        noDataText: "Aucune adresse email",
                        scrollingEnabled: false,
                        itemTemplate: function (itemData, itemIndex, itemElement) {
                            itemElement.css("padding", "5px")
                            Me.objet.bddRef.getObjet(itemData).objetMetier.templateTitleEmail(itemElement, objet.data.id_utilisateur)
                        }
                    }).dxList("instance")
                    objet.bddRef.mAddFunctionOnModifiedItemData(["compte_email", "compte_email_utilisateur", "utilisateur"], itemElement, function (action, itemData) {
                        dxList.option("dataSource", Me.objet.bddRef.getObjet("utilisateur", objet.data.id_utilisateur).objetMetier.mGetLstDataCompteEmail())
                    })

                    var $Td = $("<td style='width:1px;vertical-align:top;'></td>").appendTo($Tr)
                    $("<div style='display:inline-block;'/>").appendTo($Td).dxCtrlButton({
                        icon: "fas fa-at",
                        icon2: "fas fa-certificate",
                        colorIcone2: theme.colorBtIcon2,
                        opacityIcone2: "0.9",
                        txtTooltip: "Ajouter une nouvelle adresse email",
                        height: 36,
                        width: 36,
                        onClick: function (e) {
                            objet.bddRef.getObjet("compte_email").objetMetier.mShowPopupNew(objet.data)
                        }
                    })
                },
                colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
            }]

            var blocForm = $("<div/>").appendTo(contentElement).dxCtrlForm({
                formData: objet.data,
                items: lstItem,
                visible: true
            }).dxCtrlForm("instance");
        }

        function mSave(nomChamp) {
            Me.mMajPage()
            dxWarning.mUpdate();
            if (typeof nomChamp != 'undefined') {
                objet.mSaveChamp(nomChamp, function () {
                    Me.mMajPage()
                    if (typeof option.onChange != 'undefined') option.onChange(objet)
                });
            }
        }
    }

    //ITEMTEMPLATE
    this.itemTemplate = function (contentElement) {
        contentElement.css("text-align", "left");
        contentElement.css("padding-left", "0");
        var $Table = $("<table style='width:100%'/>").appendTo(contentElement);
        var $Tr = $("<tr/>").appendTo($Table);
        var $Td = $("<td style='width:1px'/>").appendTo($Table);
        $("<div/>").appendTo($Td).dxCtrlImageData({
            bddCtrl: Me.objet.bddRef,
            data: objet.data,
            onClick: null,
            allowClick: false,
            size: 30
        });
        var $Td = $("<td style='width:100%;vertical-align:middle;padding-left:5px;'>" + Me.mGetLib1() + "</td>").appendTo($Table);
    }

    this.mGetNomUsuelCourant = function () {
        var nomUsuel = objet.data.nom_usuel
        if (typeof nomUsuel == 'undefined' || nomUsuel == null || nomUsuel.length == 0) {
            nomUsuel = ((objet.data.prenom == null) ? "" : objet.data.prenom)
            if (objet.data.nom != null && objet.data.nom.length > 0) nomUsuel = ((nomUsuel.length > 0) ? " " : "") + objet.data.nom
        }
        return nomUsuel
    }

    this.shading = true;

    this.mMajPage = function (supp) {
        var lst = $("body").find(".dxgriduti")
        for (var i = 0; i < lst.length; i++) {
            var dxCtrl = $(lst[i])
            dxCtrl.getInstance().component().refresh(false);
        }
    }

    this.mShowNewUtilisateur = function (option) {
        if (typeof option == 'undefined') option = {}
        var dataUti = objet.mGetNewData()
        var lstItem = mGetLstItemEntete(dataUti, 16)
        var dxCtrlPwd = null
        lstItem.push({
            dataField: "pwd", label: { visible: false, text: "Mot de passe", location: "left" },
            template: function (itemData, itemElement) {
                $("<div>Mot de passe:</div>").appendTo(itemElement)
                dxCtrlPwd = $("<div/>").appendTo(itemElement).dxCtrlPwd({
                    value: "",
                    maxLength: 50,
                    onlyNumber: false,
                    minLength: 8,
                    inputAttr: { autocomplete: 'new-password' },
                    onValueChanged: function (value) { dataUti.pwd = value; }
                }).dxCtrlPwd("instance");
            },
            colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
        })

        //if (Me.objet.bddRef.nom_base.endsWith("_aagest")) {
        //    //on est sur la base parametre
        //    dataUti.administrateur = 1
        //    if (Me.objet.bddRef.utiCourant.is_total == "1") {
        //        //on rajoute la possibilité de créer des hyper_administrateur
        //        dataUti.super_administrateur = 1
        //        lstItem.push({
        //            dataField: "is_dieu", label: { visible: false, text: "Hyper administrateur", location: "left" },
        //            template: function (itemData, itemElement) {
        //                if (Me.objet.bddRef.utiCourant.is_total == "1") {
        //                    $("<div/>").appendTo(itemElement).dxCtrlCheckBox({
        //                        labelMode: 'floating',
        //                        label: "Hyper-administrateur",
        //                        text: "accès à tous les environnements et à toutes les bases",
        //                        onValueChanged: function (e) {
        //                            if (Me.objet.bddRef.utiCourant.is_total == "0") {
        //                                mNotify("Vous ne pouvez pas mettre un utilisateur en hyper-administrateur. Contactez le service informatique pour cela.", "warning", 8000)
        //                                e.component.option("value", false)
        //                                return;
        //                            }
        //                            dataUti.is_dieu = ((e.value) ? "1" : "0")
        //                        }
        //                    })
        //                }
        //            },
        //            colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
        //        })
        //    }
        //} else {
        //on est sur une base particulière
        //on rajoute des utilisateurs administrateur ou non
        dataUti.super_administrateur = 0
        dataUti.administrateur = 0
        dataUti.theme = parametre.theme_defaut
        //if (typeof option.showCheckAdministrateur == 'undefined' || option.showCheckAdministrateur) {
        lstItem.push({
            dataField: "administrateur", label: { visible: false, text: "Administrateur", location: "left" },
            template: function (itemData, itemElement) {
                //if (Me.objet.bddRef.utiCourant.is_total == "1") {
                $("<div/>").appendTo(itemElement).dxCtrlCheckBox({
                    text: "Utilisateur administrateur",
                    hint: "Les utilisateurs administrateurs ont accès à la création, consultation et modification des utilisateurs.",
                    value: (dataUti.administrateur == 1),
                    onValueChanged: function (e) {
                        dataUti.administrateur = ((e.value) ? "1" : "0")
                    }
                })
                //}
            },
            colSpanXs: 16, colSpanSm: 16, colSpanMd: 16, colSpanLg: 16
        })
        //}
        //}
        var pop = $("<div/>").appendTo($DivGeneral).dxCtrlPopupBase({
            title: "Nouvel utilisateur",
            width: 600,
            height: 'auto',
            showMaximize: false,
            contentTemplate: function (contentElement) {
                var form = $("<div/>").appendTo(contentElement).dxCtrlForm({
                    formData: dataUti,
                    items: lstItem
                }).dxCtrlForm("instance");

                //$("<div style='text-align:center;color:orange;padding:10px 0 20px 0;'>Pour sa première connexion, votre utilisateur devra créer son mot de passe<br/>via le lien <u>J'ai oublié mon mot de passe</u> sur la page de connexion.</div>").appendTo(contentElement)

                //var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
                //var $Tr = $("<tr/>").appendTo($Table)
                //var $Td = $("<td style='width:100%'/>").appendTo($Tr)
                //var $Td = $("<td style='width:1px;padding-right:5px;'/>").appendTo($Tr)
                //$("<div/>").appendTo($Td).dxCtrlButton({
                //    text: "Valider",
                //    hint: "Valider la création de l'utilisateur",
                //    onClick: function (e) {
                //        if (dataUti.adresse_email == null || dataUti.adresse_email.length == 0) {
                //            mNotify("Veuillez saisir une adresse email", "warning", 8000)
                //            return;
                //        }
                //        //on valide l'adresse email
                //        $("<div/>").appendTo("body").dxCtrlSaisieCode({
                //            bddCtrl: Me.objet.bddRef,
                //            title: "Confirmez l'adresse email",
                //            adresse_email: dataUti.adresse_email,
                //            onValide: function () {
                //                mSavePopup(false);
                //            },
                //            onCancel: function () {
                //            }
                //        })
                //    }
                //})
                //var $Td = $("<td style='width:1px;padding-right:5px;'/>").appendTo($Tr)
                //$("<div/>").appendTo($Td).dxCtrlButton({
                //    text: "Valider avec email info",
                //    hint: "Valider la création de l'utilisateur et envoyer un email pour l'informer",
                //    onClick: function (e) {
                //        if (dataUti.adresse_email == null || dataUti.adresse_email.length == 0) {
                //            mNotify("Veuillez saisir une adresse email", "warning", 8000)
                //            return;
                //        }
                //        //on valide l'adresse email
                //        $("<div/>").appendTo("body").dxCtrlSaisieCode({
                //            bddCtrl: Me.objet.bddRef,
                //            title: "Confirmez l'adresse email",
                //            adresse_email: dataUti.adresse_email,
                //            onValide: function () {
                //                mSavePopup(true);
                //            },
                //            onCancel: function () {
                //            }
                //        })
                //    }
                //})
                //var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                //$("<div/>").appendTo($Td).dxCtrlButton({
                //    text: "Annuler",
                //    onClick: function (e) {
                //        pop.hide();
                //    }
                //})
                mAddButtonOkAnnuler(contentElement,
                    function () { //ok
                        if (dataUti.adresse_email == null || dataUti.adresse_email.length == 0) {
                            mNotify("Veuillez saisir une adresse email", "warning", 8000)
                            return;
                        }
                        if (dataUti.pwd == null || dataUti.pwd.length == 0) {
                            mNotify("Veuillez saisir un mot de passe", "warning", 8000)
                            dxCtrlPwd.focus()
                            return;
                        }
                        if (!dxCtrlPwd.isOk()) {
                            mNotify("La saisie de votre mot de passe n'est pas correcte", "warning", 8000)
                            dxCtrlPwd.focus()
                            return;
                        }
                        //on valide l'adresse email
                        $("<div/>").appendTo("body").dxCtrlSaisieCode({
                            bddCtrl: Me.objet.bddRef,
                            title: "Confirmez l'adresse email",
                            adresse_email: dataUti.adresse_email,
                            from: "Creation utilisateur (cObjetUtilisateurMetier)",
                            onValide: function () {
                                mSavePopup();
                            },
                            onCancel: function () {
                            }
                        })
                    })
            },
            onHiding: function (e) { }
        }).dxCtrlPopupBase("instance")
        pop.show();

        function mSavePopup(sendEmailInfo) {
            pop.hide();
            jaugeDemarrage.mShow()
            Me.objet.bddRef.getObjet(dataUti).mSave(function (data) {
                //if (Me.objet.bddRef.mGetArray("utilisateur_para_email") != null) {
                //    //on utilise le module mail
                //    //on crée le utilisateur_para_email
                //    var dataUtiPAraEmail = Me.objet.bddRef.getObjet("utilisateur_para_email").mGetNewData()
                //    data.id_utilisateur = data.id_utilisateur
                //    Me.objet.bddRef.getObjet(dataUtiPAraEmail).mSave(function (data) {
                //        Me.objet.bddRef.getObjet(dataUti).mShowPopup();
                //        page.jauge.mHide(50)
                //    })
                //} else {
                //    //on utilise pas le module mail
                if (sendEmailInfo) {
                    Me.objet.bddRef.mAjaxCall({ "command": "sendemailcreautilisateur", "adresse_email": dataUti.adresse_email })
                }
                Me.objet.bddRef.mReloadTable(["agenda", "compte_email", "compte_email_utilisateur"], function () {
                    Me.objet.bddRef.getObjet(dataUti).mShowPopup();
                    jaugeDemarrage.mHide()
                })
                //}
            });
        }
    }

    this.mShowList = function (funcSelectionChanged, dataSource, libTitle) {
        var popContentElement = null;
        var pop = $("<div/>").appendTo("body").dxCtrlPopupBase({
            position: {
                my: "right top",
                at: "right top",
                of: "body"
            },
            width: 800,
            height: "100%",
            showTitle: true,
            showMaximize: false,
            title: ((typeof libTitle == 'undefined') ? "Choisir un utilisateur" : libTitle),
            contentTemplate: function (contentElement) {
                popContentElement = contentElement
                popContentElement.css("padding-top", 0)
            },
            onShown: function (e) {
                var optionSdg = {
                    dataSource: dataSource,
                    height: popContentElement.innerHeight(),
                    getMaxHeight: function () { return popContentElement.innerHeight() },
                    noDataText: "Aucun utilisateur",
                    noNew: true,
                    onRowClickAction: function (e) {
                        var idUti = e.data.id_utilisateur
                        funcSelectionChanged(idUti)
                        pop.hide()
                    },
                    allowDelete: false
                }
                var dxGridApp = Me.objet.bddRef.getObjet("utilisateur").contentTemplateGrid(popContentElement, optionSdg);
            }
        }).dxCtrlPopupBase("instance")
        pop.show();
    }

    this.mGetLstDataCompteEmail = function () {
        var lstEmail = Me.objet.bddRef.mGetArray("compte_email").filter(function (o) {
            return Me.objet.bddRef.mGetArray("compte_email_utilisateur").filter(function (oo) { return oo.id_utilisateur == objet.data.id_utilisateur && oo.id_compte_email == o.id_compte_email }).length > 0
        })
        return lstEmail
    }

    this.mGetLstDataCompteEmailUtilisateur = function () {
        return Me.objet.bddRef.mGetArray("compte_email_utilisateur").filter(function (oo) { return oo.id_utilisateur == objet.data.id_utilisateur })
    }

    this.mGetDataCompteEmailDefaut = function () {
        var lstDataCompteEmail = this.mGetLstDataCompteEmail()
        var dataCompteEmail = lstDataCompteEmail.filter(function (o) {
            return Me.objet.bddRef.mGetArray("compte_email_utilisateur").filter(function (oo) {
                return oo.id_utilisateur == Me.objet.bddRef.utiCourant.id_utilisateur && oo.id_compte_email == o.id_compte_email && oo.defaut == "1"
            }).length > 0
        })[0]
        if (typeof dataCompteEmail == 'undefined' && lstDataCompteEmail.length > 0) {
            dataCompteEmail = lstDataCompteEmail[0]
            dataCompteEmilUti = Me.objet.bddRef.mGetArray("compte_email_utilisateur").filter(function (o) { return o.id_compte_email == dataCompteEmail.id_compte_email })[0]
            dataCompteEmilUti.defaut = "1"
            Me.objet.bddRef.getObjet(dataCompteEmilUti).mSaveChamp("defaut")
        }
        return dataCompteEmail
    }

    //GESTION ADRESSE EMAIL
    this.mGetLstHoraire = function () {
        var value = []
        if (objet.data.horaire_envoi != null && objet.data.horaire_envoi.length > 0) objet.data.horaire_envoi.split("||").forEach(function (interval) {
            var timeDebut = interval.split("|")[0]
            var timeFin = interval.split("|")[1]
            value.push({
                timeDebut: new Date(2023, 1, 2, parseInt(timeDebut.split(":")[0]), parseInt(timeDebut.split(":")[1]), 0),
                timeFin: new Date(2023, 1, 2, parseInt(timeFin.split(":")[0]), parseInt(timeFin.split(":")[1]), 0)
            })
        })
        return value
    }

    this.mGetProchaineDateEnvoi = function (dat) {
        return Me.objet.bddRef.getObjet("com_destinataire").objetMetier.mGetProchaineDateEnvoi(dat, objet.data.horaire_envoi, objet.data.jour_envoi)
    }

    this.mGetLookUpForFilterBuilder = function () {
        var lstUti = []
        objet.bddRef.mGetArray("utilisateur").forEach(function (data) {
            lstUti.push({ id: data.id_utilisateur, nom: objet.bddRef.getObjet(data).mGetLib1() })
        })
        return {
            dataSource: lstUti,
            displayExpr: "nom",
            valueExpr: "id",
            placeholder: "Sélectionner des utilisateurs"
        }
    }

    this.mShowPopup = function (optionPopup) {
        if (typeof optionPopup == "undefined" || optionPopup == null) optionPopup = {}
        if (parametre.baseAppli.para.is_multi_utilisateur == "1") {
            optionPopup.onTitleCmdTemplate = function (titleElement, popupBase) {
                titleElement.css("width", "130px")
                if (Me.objet.bddRef.utiCourant.administrateur == 1) {
                    $("<div/>").appendTo(titleElement).dxCtrlButton({
                        text: "Supprimer",
                        hint: "Supprimer l'utilisateur",
                        onClick: function (e) {
                            if (Me.objet.data.id_utilisateur == Me.objet.bddRef.utiCourant.id_utilisateur) {
                                mNotify("Vous ne pouvez pas supprimer votre profil quand vous êtes connecté.<br/>Pour supprimer votre profile, connecté vous via un autre profil administrateur.", "warning", 6000)
                            } else {
                                Me.objet.bddRef.mAjaxCall({ command: "utilisateurasfacturevalide", id_utilisateur: Me.objet.data.id_utilisateur }, function (data) {
                                    if (data.nb_facture_valide == 0) {
                                        var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                                            target: e.component.element(),
                                            width: 350,
                                            showCloseButton: false,
                                            visible: true,
                                            contentTemplate: function (contentElement) {
                                                contentElement.css("white-space", "normal")
                                                contentElement.css("padding", "20px")
                                                $("<div>Pour supprimer un utilisateur,<br/>vous devez choisir un utilisateur sur lequel<br/>migrer tout les éléments de la base de données auxquels cet utilisateur est lié (structures, contact, dossier..).<br/><br/>Veuillez sélectionner l'utilisateur<br/>sur lequel migrer ces éléments.</div>").appendTo(contentElement)
                                                Me.objet.bddRef.mGetArray("utilisateur").filter(function (o) { return o.date_abandon == null && o.is_robot == 0 && o.id_utilisateur != Me.objet.data.id_utilisateur }).forEach(function (dataUti) {
                                                    var objUti = Me.objet.bddRef.getObjet(dataUti)
                                                    var $DivVide = $("<div class='state-hover dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-text' " +
                                                        "style='padding:10px 0;width:100%;height:auto;text-align:left;margin:10px 0;line-height:1;'>" +
                                                        "<div class='contenu' style='padding:5px;'>" +
                                                        "<span style='font-size:100%;font-style:italic' class='detail'>Migrer sur: <b>" + objUti.mGetLib1() + "</b>"
                                                        + "</span>" +
                                                        "</div>" +
                                                        "</div>").appendTo(contentElement)
                                                    $DivVide.on("click", function (e) {
                                                        tt.hide()
                                                        mShowDelWithUtilisateur(objUti)
                                                    })
                                                })
                                            }
                                        }).dxCtrlTooltip("instance");
                                        tt.show();

                                        function mShowDelWithUtilisateur(objUti) {
                                            var tt2 = $("<div/>").appendTo("body").dxCtrlTooltip({
                                                target: e.component.element(),
                                                width: 400,
                                                showCloseButton: false,
                                                visible: true,
                                                contentTemplate: function (contentElement) {
                                                    contentElement.css("white-space", "normal")
                                                    contentElement.css("padding", "20px")
                                                    $("<div style='font-size:140%;'>Vous allez supprimer l'utilisateur<br/><b>" + Me.objet.mGetLib1() + "</b><br/>et transférer ses éléments liés sur l'utilisateur<br/><b>" + objUti.mGetLib1() + "</b></div>").appendTo(contentElement)

                                                    $("<div style='padding-top:20px;'>L'agenda de l'utilisateur sera entièrement supprimé avec tous ses rendez-vous</div>").appendTo(contentElement)

                                                    var lstDataCptEmail = Me.objet.bddRef.mGetArray("compte_email").filter(function (o) { return o.id_utilisateur == Me.objet.data.id_utilisateur })
                                                    if (lstDataCptEmail.length > 0) {
                                                        $("<div style='padding-top:20px;color:orangered;'>Vous allez supprimer les comptes emails de l'utilisateur<br/>ainsi que tous les messages recus et envoyés (hors mailing)<br/>des ces comptes emails</div>").appendTo(contentElement)
                                                        lstDataCptEmail.forEach(function (data) {
                                                            $("<div style='color:orangered;'><u>" + data.adresse_email + "</u></div>").appendTo(contentElement)
                                                        })
                                                        $("<div style='color:orangered;'><i>(Si vous voulez garder ces comptes emails,<br/>vous devez migrer ces adresses emails sur un autre utilisateur<br/>via la config de l'adresse email)</i></div>").appendTo(contentElement)
                                                    }

                                                    $("<div style='margin-top:10px;'>A la fin de la suppression, votre environnement sera rechargé</div>").appendTo(contentElement)

                                                    $("<div style='margin-top:20px;'/>").appendTo(contentElement).dxCtrlButton({
                                                        html: "Supprimer l'utilisateur<br/>⚠ Action définitive ⚠",
                                                        width: 250,
                                                        onClick: function (e) {
                                                            tt2.hide()
                                                            jaugeDemarrage.mShow()
                                                            Me.objet.bddRef.mAjaxCall({
                                                                command: "migreetdeleteutilisateur",
                                                                id_utilisateur_todel: Me.objet.data.id_utilisateur,
                                                                id_utilisateur_dest: objUti.data.id_utilisateur
                                                            }, function (data) {
                                                                forcerFermetureNavigateur = true;
                                                                window.location.reload()
                                                            }, null, function () {
                                                                jaugeDemarrage.mHide()
                                                                mNotify("Impossible de supprimer l'utilisateur", "warning", 6000)
                                                            })
                                                        }
                                                    })
                                                }
                                            }).dxCtrlTooltip("instance");
                                            tt2.show();
                                        }
                                    } else {
                                        mNotify("Cette utilisateur est lié à des factures validée. Vous ne pouvez pas le supprimer, seulement l'abandonner.", "error", 6000)
                                    }
                                })
                            }

                        }
                    })
                }
            }
        }
        objet.mShowPopupInterne(optionPopup)
    }

    return this;
}

//function mSaveParaJsonUtilisateur() {
//    //dataToBeSent = JSON.clone(Me.objet.bddRef.utiCourantParaJson))
//    mMigreDateToNet(Me.objet.bddRef.utiCourantParaJson)
//    if (parametre.isLocalhost && JSON.stringify(Me.objet.bddRef.utiCourantParaJson).contains("''''''''")) {
//        alert("Erreur, le json uti est pas bon")
//        alert(mGetStackTrace());
//        debugger;
//    }
//    Me.objet.bddRef.mAjaxCall({ command: "savebdd.utiCourantParaJson", para_json: JSON.stringify(Me.objet.bddRef.utiCourantParaJson) });
//    mMigreFormatDateFromJson(Me.objet.bddRef.utiCourantParaJson);
//}